// extracted by mini-css-extract-plugin
export default {"container":"Home_container__GtCQ6","text":"Home_text__GfPoQ","text__bold":"Home_text__bold__vIdbH"};